import * as React from 'react';
import { Worker, Viewer, ViewMode } from '@react-pdf-viewer/core';
import $ from 'jquery';
import { getFilePlugin } from '@react-pdf-viewer/get-file';
import { pageNavigationPlugin } from '@react-pdf-viewer/page-navigation';
import { zoomPlugin } from '@react-pdf-viewer/zoom';
import { fullScreenPlugin } from '@react-pdf-viewer/full-screen';
import imgHeartR from '../../assets/images/heart-red.png';
import imgHeartW from '../../assets/images/heart-red-outline.png';

import '@react-pdf-viewer/zoom/lib/styles/index.css';

import './react-pdf-viewer.css';
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/page-navigation/lib/styles/index.css';
import '@react-pdf-viewer/full-screen/lib/styles/index.css';
import { addFavouritePdf, getFavouritePdf, callAnalyticsAPI, removeFavouritePdf } from "../../api/user"

interface ToolbarOptionsProps {
    fileUrl: string;
    contentInfo: { navigation_ref: string, title: string, ref: string };
    contentParentInfo: { ref: string, area: any };
}

const PdfViewer: React.FC<ToolbarOptionsProps> = ({ fileUrl, contentInfo, contentParentInfo, changeLoaderStatus }) => {
    const [checkAlreadyFav, setcheckAlreadyFav] = React.useState(false)
    const zoomPluginInstance = zoomPlugin();
    const { ZoomInButton, ZoomOutButton, ZoomPopover } = zoomPluginInstance;
    
    const getFilePluginInstance = getFilePlugin();
    const { DownloadButton } = getFilePluginInstance;
    const pageNavigationPluginInstance = pageNavigationPlugin();
    const { CurrentPageInput, GoToNextPageButton, GoToPreviousPageButton } = pageNavigationPluginInstance;
    const [currentPdfId, setCurrentPdfId] = React.useState(0);
    const fullScreenPluginInstance = fullScreenPlugin();
    const { EnterFullScreenButton } = fullScreenPluginInstance;

    React.useEffect(() => {
        setcheckAlreadyFav(false)

        let user_id = sessionStorage.getItem("user_id");

        if (user_id) {

            getFavouritePdf({ user_id: user_id }).then((val) => {

                if (val.data.response === "success") {

                    let wishlists = val.data.wishlists;

                    if (contentInfo.navigation_ref) {

                        wishlists.map(wish => {
             

                            if (contentInfo.navigation_ref === wish['section_id']) {
                                setcheckAlreadyFav(true)
                                setCurrentPdfId(wish['id'])
                            }

                        })


                    }

                }

                //console.log(val.data)
            })




            //call analytics api
            let reqData: any = {};
            reqData.user_id = user_id;
            reqData.area_id = contentParentInfo.area;
            if (contentInfo.navigation_ref === undefined) {
                reqData.resource_id = contentInfo.ref
            } else {
                reqData.resource_id = contentInfo.navigation_ref
            }
            reqData.resource_type = "pdf";
            reqData.prev_area = 0;
            reqData.spent_time = 0;
            reqData.total_time = 0;
            reqData.video_status = 0;
            reqData.download = 0;
            reqData.guided_mode = 0;

            callAnalyticsAPI(reqData)

        }

    }, [contentInfo])
    const changeHeart = (e) => {
        if ($(e.target).hasClass('active')) {
            $(e.target).attr('src', imgHeartW)
            $(e.target).removeClass('active')
        } else {
            $(e.target).attr('src', imgHeartR)
            $(e.target).addClass('active')
        }
    }

    const removeFavourite = () => {


        let user_id = sessionStorage.getItem("user_id");

        if (user_id) {
            //changeLoaderStatus(true)
            //  alert(currentPdfId)
            removeFavouritePdf({ id: currentPdfId, user_id: user_id }).then((val) => {
                setcheckAlreadyFav(false)

                if (val.data.response === "success") {
                    //alert("Successfully removed.")

                    // changeLoaderStatus(false)
                    // loadWishList();

                }
            })
        }
    }
    const addToFavourite = () => {


        let user_id = sessionStorage.getItem("user_id");

        if (user_id) {


            let reqObj = {
                user_id: user_id,
                // section_id: contentInfo.navigation_ref,
                title: contentInfo.title,
                location: contentParentInfo.area,
            }

            if (contentInfo.navigation_ref === undefined) {
                reqObj.section_id = contentInfo.ref
            } else {
                reqObj.section_id = contentInfo.navigation_ref
            }


            let session_id = sessionStorage.getItem("session_id");
            if (session_id) {

                reqObj.session_id  = session_id

            }

            let createFav = addFavouritePdf(reqObj);
            //changeLoaderStatus(true)
            createFav.then((val) => {
                //changeLoaderStatus(false)
                if (val.data.response === "success") {
                    // alert("Successfully added to favourite.")
                    setcheckAlreadyFav(true)
                    setCurrentPdfId(val.data.wishlist.id)

                }

            })

        }

    }
    const DownloadCount = () => {

        let user_id = sessionStorage.getItem("user_id");

        if (user_id) {

            // console.log(contentParentInfo)
            // console.log(contentInfo.navigation_ref)

            let reqData: any = {}
            reqData.user_id = user_id;
            reqData.area_id = contentParentInfo.area;
            if (contentInfo.navigation_ref === undefined) {
                reqData.resource_id = contentInfo.ref
            } else {
                reqData.resource_id = contentInfo.navigation_ref
            }

            // console.log(reqData.resource_id)
            reqData.resource_type = "pdf";
            reqData.prev_area = 0;
            reqData.spent_time = 0;
            reqData.total_time = 0;
            reqData.video_status = 0;
            reqData.download = 1;
            reqData.guided_mode = 0;

            callAnalyticsAPI(reqData)

        }
    }

    return (
        <div
            className="rpv-core__viewer"
            style={{
                border: '1px solid rgba(0, 0, 0, 0.3)',
                display: 'flex',
                flexDirection: 'column',
                height: '70vh',
                minHeight: '150px'
            }}
        >
            <div
                style={{
                    alignItems: 'center',
                    backgroundColor: '#eeeeee',
                    borderBottom: '1px solid rgba(0, 0, 0, 0.1)',
                    display: 'flex',
                    padding: '4px',
                }}
            >
                <ZoomOutButton />
                <ZoomPopover />
                <ZoomInButton />
                <GoToPreviousPageButton />
                <CurrentPageInput />
                <EnterFullScreenButton />
                <GoToNextPageButton />
                <div onClick={DownloadCount}>
                    <DownloadButton />
                </div>
                <div style={{ padding: '0px 2px' }}>{
                    checkAlreadyFav ? (
                        <img className='heart ' src={imgHeartR} alt='' onClick={removeFavourite} ></img>
                    ) : (
                        <img className='heart ' src={imgHeartW} alt=''
                            onMouseEnter={changeHeart}
                            onMouseLeave={changeHeart}
                            onClick={addToFavourite}
                        ></img>
                    )
                }
                </div>
            </div>
            <Worker workerUrl="https://unpkg.com/pdfjs-dist@2.16.105/build/pdf.worker.js">
                <div
                    className="rpv-core__viewer"
                    style={{
                        width: '100%',
                        marginLeft: 'auto',
                        marginRight: 'auto',
                    }}
                >
                    <Viewer fileUrl={fileUrl}
                        viewMode={ViewMode.SinglePage}
                      
                        plugins={[getFilePluginInstance, pageNavigationPluginInstance, zoomPluginInstance, fullScreenPluginInstance]} />

                </div>
            </Worker>

        </div>
    );
};

export default PdfViewer;